import EntityBase from '@/data/EntityBase';

export default class IntegrationState extends EntityBase({
  updating: 0,
}) {}
